document.addEventListener('DOMContentLoaded', function() {
      Typed.new('span.type', {
        strings: ["Education.", "E-Commerce.", "Media.", "Government.", "Agencies.", "Associations.", "Hospitality.", "Small Business.", "Non-Profit.", "Law Firms.", "Main Street."],
        typeSpeed: 0,
        loop: true,
        loopCount: null,
        backDelay: 900,
        shuffle: true
      });
  });